import { useState } from "react";
import { roleAPI } from "../rolesService";
import { handleApiError } from "../../../../services/axiosService";

export const useUserAssignment = () => {
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchRoleUsers = async (roleId) => {
    try {
      setIsLoading(true);
      setSelectedUsers([]);
      const { data } = await roleAPI.getRoleUsers(roleId);
      if (data && data.length > 0) {
        setSelectedUsers(data);
      }
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsLoading(false);
    }
  };

  const searchUsers = async (searchTerm) => {
    try {
      const { data } = await roleAPI.searchUsers(searchTerm, searchTerm ? 20 : 10);
      return data.filter((user) => !selectedUsers.some((assigned) => assigned.id === user.id));
    } catch (error) {
      handleApiError(error);
      return [];
    }
  };

  const assignUser = async (roleId, userId) => {
    try {
      const response = await roleAPI.assignUser(roleId, userId);
      setSelectedUsers([...selectedUsers, response.data]);

      return true;
    } catch (error) {
      handleApiError(error);
      return false;
    }
  };

  const removeUser = async (roleId, userId) => {
    try {
      await roleAPI.removeUser(roleId, userId);
      setSelectedUsers((prev) => prev.filter((user) => user.id !== userId));
      return true;
    } catch (error) {
      handleApiError(error);
      return false;
    }
  };

  const resetUsers = () => {
    setSelectedUsers([]);
  };

  return {
    selectedUsers,
    isLoading,
    fetchRoleUsers,
    searchUsers,
    assignUser,
    removeUser,
    resetUsers
  };
};
